/**
 * External dependencies
 */
import React from "react";
import classnames from "classnames";
import { Text, Box } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */

const NavListLink = ({ active, children, suffix, label, path, onClick }) => {
  const classes = classnames("nav-list__link", { active });
  return (
    <a className={classes} href={path} onClick={onClick}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="spaceBetween"
        width="full"
      >
        {label && <Text>{label}</Text>}
        {suffix}
      </Box>
      {children}
    </a>
  );
};

export default NavListLink;
